import { render, staticRenderFns } from "./changeNav.vue?vue&type=template&id=05d00fb8&scoped=true"
import script from "./changeNav.vue?vue&type=script&lang=js"
export * from "./changeNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d00fb8",
  null
  
)

export default component.exports